import React from "react";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Countdown } from "@/components/Countdown";
import { eventConfig } from "@/config/eventConfig";

const FinalCta = ({ onRegister }) => {
  const { finalCta, event } = eventConfig;
  return (
    <section data-testid="final-cta" className="relative overflow-hidden" style={{ background: "#126F6A" }}>
      <div className="absolute inset-0 bg-grid-navy opacity-20" aria-hidden="true" />
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20 text-center">
        <Reveal>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight text-balance">
            {finalCta.heading}
          </h2>
        </Reveal>
        <Reveal delay={0.05}>
          <p className="mt-4 text-lg font-semibold" style={{ color: "#FFD16F" }}>
            {event.dateLabelShort} · {event.timeLabel.split("\u2013")[0].trim()}
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-8 flex justify-center">
            <Countdown variant="block" className="text-center [&_p]:justify-center [&>div]:justify-center [&_p]:inline-flex" />
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <button
            data-testid="final-cta-register-button"
            onClick={onRegister}
            className="mt-8 inline-flex items-center gap-2 h-14 px-8 rounded-xl bg-[#F7B838] text-[#071524] text-base font-semibold hover:bg-[#FFD16F] transition-colors active:scale-[0.98] shadow-[0_14px_40px_rgba(7,21,36,0.25)]"
          >
            {finalCta.ctaLabel} <ArrowRight size={18} />
          </button>
        </Reveal>
      </div>
    </section>
  );
};

export default FinalCta;
